var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoWrapper",class:_vm.fadeClass,style:({ transition: _vm.fadeTime + 'ms linear opacity' })},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-default-skin vjs-16-9"})])
}
var staticRenderFns = []

export { render, staticRenderFns }